import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getGroups = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/groups`, {params});
};

export {
    getGroups
}